import { AccountsPage } from './AccountsPage';

/**
 * Bu feature'in EKRAN KAYDI. `src/app/screens.ts` bunu tek satirla yayar
 * (`...accountScreens`), boylece router.tsx'e hic dokunulmaz — bkz. o dosyanin
 * basligindaki gerekce.
 *
 * AYNI BILESEN IKI KIMLIGE bagli: musteri ve buro ayni IBAN defterini goruyor;
 * aralarindaki tek fark yetki ve o da ekranin icinde veriden okunuyor
 * (`manageAccounts` -> duzenleme). Iki kopya, birinde duzeltilen bir IBAN
 * hatasinin otekinde yasamasi demekti.
 *
 * Buro rotasi menude ZATEN `viewAccounts` ile korunuyor (src/layout/menus.ts);
 * burada tekrar edilmez.
 */
export const accountScreens = {
  'customer.accounts': AccountsPage,
  'exchange.accounts': AccountsPage,
} as const;
